var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 5.81V11.9L18.37 10.5C17.59 9.83 16.33 9.83 15.55 10.5L11.39 14.07C10.61 14.74 9.35 14.74 8.57 14.07L8.23 13.79C7.52 13.17 6.39 13.11 5.59 13.65L0.67 16.95L0.56 17.03C0.19 16.23 0 15.28 0 14.19V5.81C0 2.17 2.17 0 5.81 0H14.19C17.83 0 20 2.17 20 5.81Z",
    fill: "#00D3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 8.37719C8.31456 8.37719 9.38012 7.31163 9.38012 5.99719C9.38012 4.68275 8.31456 3.61719 7.00012 3.61719C5.68568 3.61719 4.62012 4.68275 4.62012 5.99719C4.62012 7.31163 5.68568 8.37719 7.00012 8.37719Z",
    fill: "#00D3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.9025V14.1925C20.0001 17.8325 17.8301 20.0025 14.1901 20.0025H5.81006C3.26006 20.0025 1.42006 18.9325 0.560059 17.0325L0.670059 16.9525L5.59006 13.6525C6.39006 13.1125 7.52006 13.1725 8.23006 13.7925L8.57006 14.0725C9.35006 14.7425 10.6101 14.7425 11.3901 14.0725L15.5501 10.5025C16.3301 9.8325 17.5901 9.8325 18.3701 10.5025L20.0001 11.9025Z",
    fill: "#00D3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon06);
export default __webpack_public_path__ + "static/media/chat-icon-06.805cc109be8302840ad9c22144d203db.svg";
export { ForwardRef as ReactComponent };